import { Link, useNavigate } from 'react-router-dom';
import { useCart } from './context/CartContext';
import { useState, useRef, useEffect } from 'react';
import './styles/Header.css';

// Simple auth context replacement
const useAuth = () => ({
  user: true,
  login: () => { },
  logout: () => { }
});

export const Header = () => {
  const { itemCount } = useCart();
  const { user, login, logout } = useAuth();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = async () => {
    logout();
    setIsDropdownOpen(false);
    navigate('/');
  };

  const handleDevLogin = () => {
    login();
    setShowLogin(false);
    navigate('/business-tool-marketplace');
  };

  const handleFakeSignup = () => {
    login();
    setShowLogin(false);
    navigate('/creator-hub');
  };

  return (
    <div className='header-container'>
      <header className="header">
        <div className="header-content">
          <Link to="/home" className="logo">
            Business Tools
          </Link>
          <nav className="nav">
            <Link to="/marketplace" className="nav-link">Browse Tools</Link>
            <Link to="/business-tool-marketplace/upload" className="nav-link">Upload Tool</Link>
            <Link to="/business-tool-marketplace/cart" className="nav-link cart-link">
              <span className="cart-icon">🛒</span>
              {itemCount > 0 && <span className="cart-count">{itemCount}</span>}
            </Link>
            {!user ? (
              <button className="login-btn" onClick={() => setShowLogin(true)}>
                Dev Login
              </button>
            ) : (
              <div className="user-menu" ref={dropdownRef}>
                <button
                  className="profile-link"
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                >
                  <img
                    src={user?.user_metadata?.avatar_url || 'https://ui-avatars.com/api/?name=' + encodeURIComponent(user?.email || 'User') + '&background=007bff&color=fff'}
                    alt="Profile"
                    className="profile-image"
                  />
                </button>
                <div className={`user-dropdown ${isDropdownOpen ? 'show' : ''}`}>
                  <Link to="/creator/me" className="dropdown-item" onClick={() => setIsDropdownOpen(false)}>Profile</Link>
                  <button className="dropdown-item" onClick={() => { setIsDropdownOpen(false); navigate('/user-settings'); }}>User Settings</button>
                  <button className="dropdown-item logout" onClick={handleLogout}>Logout</button>
                </div>
              </div>
            )}
          </nav>
        </div>
        {showLogin && (
          <div className="login-modal-backdrop" onClick={() => setShowLogin(false)}>
            <div className="login-modal" onClick={e => e.stopPropagation()}>
              <h2>Dev Login</h2>
              <button onClick={handleDevLogin} className="oauth-btn google">Dev Login</button>
              <button onClick={handleFakeSignup} className="oauth-btn github">Fake Signup</button>
              <button onClick={() => setShowLogin(false)} className="close-modal">Close</button>
            </div>
          </div>
        )}
      </header>
    </div>
  );
}; 